class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    /* Added by AM — hover open for all desktop menus/submenus */
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.addEventListener('mouseenter', this.open);
    this.addEventListener('mouseleave', this.close);
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        if (e.detail) e.preventDefault();
      });
    });
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      details.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', true);
      });
      details.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', false);
      });
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.onToggle();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
